import React, {
  useEffect,
  useState
} from 'react'

import axios from 'axios'

import {
  Link,
  useNavigate,
  useParams
} from 'react-router-dom'

import { useSelector } from 'react-redux'

import Navbar from '../Navbar'

import {
  FiArrowLeft,
  FiCheckCircle,
  FiMail,
  FiShield
} from 'react-icons/fi'


export default function NewEmail() {

  const { token } = useParams()
  const navigate = useNavigate()

  const { url } =
    useSelector(state => state)

  const [email, setEmail] =
    useState('')

  const [loading, setLoading] =
    useState(false)

  const [message, setMessage] =
    useState('')

  const [error, setError] =
    useState('')


  useEffect(() => {

    if (!token) {

      navigate(
        '/dashboard/profile/'
      )
    }

  }, [token, navigate])


  const submitNewEmail =
    async (event) => {

      event.preventDefault()

      const value =
        email.trim().toLowerCase()

      setMessage('')
      setError('')


      if (!value) {

        setError(
          'Please enter your new email address.'
        )

        return
      }


      const emailPattern =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/


      if (
        !emailPattern.test(value)
      ) {

        setError(
          'Please enter a valid email address.'
        )

        return
      }


      try {

        setLoading(true)

        const formData =
          new FormData()

        formData.append(
          'email',
          value
        )


        const response =
          await axios.post(
            `${url}/auth/new-email-confirmation-link/${token}`,
            formData
          )


        const data =
          response.data


        if (data.message) {

          setMessage(
            data.message
          )

          return
        }


        setError(
          data.error ||
          'Unable to continue with this email address.'
        )


      } catch (err) {

        console.error(
          'New email error:',
          err
        )

        setError(
          err.response?.data?.detail ||
          err.response?.data?.error ||
          'Something went wrong. Please try again.'
        )

      } finally {

        setLoading(false)
      }
    }


  return (

    <div className="
      min-h-screen
      bg-[#F7F9FC]
      font-[Satoshi]
    ">

      <Navbar />


      <main className="
        lg:ml-[15em]
        min-h-screen
      ">

        <div className="
          max-w-3xl
          mx-auto
          px-5
          sm:px-6
          py-8
          lg:py-12
        ">


          <Link
            to="/dashboard/profile/"
            className="
              inline-flex
              items-center
              gap-2
              text-sm
              font-semibold
              text-gray-500
              hover:text-gray-900
              mb-7
            "
          >
            <FiArrowLeft />

            Back to profile
          </Link>


          <div className="
            bg-white
            border
            border-gray-200
            rounded-3xl
            shadow-sm
            overflow-hidden
          ">


            <div className="
              px-6
              py-6
              lg:px-8
              border-b
              border-gray-100
            ">

              <div className="
                w-12
                h-12
                rounded-xl
                bg-green-50
                text-green-600
                flex
                items-center
                justify-center
                text-xl
                mb-5
              ">
                <FiMail />
              </div>


              <h1 className="
                text-2xl
                font-bold
              ">
                Change email address
              </h1>

              <p className="
                text-sm
                text-gray-500
                mt-2
                leading-6
              ">
                Enter the new email address you want to use for your RentHub account.
              </p>

            </div>


            <form
              onSubmit={submitNewEmail}
              className="
                px-6
                py-7
                lg:px-8
              "
            >


              {message ? (

                <div className="
                  text-center
                  py-4
                ">

                  <div className="
                    w-14
                    h-14
                    rounded-2xl
                    bg-green-50
                    text-green-600
                    flex
                    items-center
                    justify-center
                    text-2xl
                    mx-auto
                    mb-4
                  ">
                    <FiCheckCircle />
                  </div>


                  <h2 className="
                    text-lg
                    font-bold
                  ">
                    Check your inbox
                  </h2>

                  <p className="
                    text-sm
                    text-gray-500
                    mt-2
                    max-w-md
                    mx-auto
                    leading-6
                  ">
                    {message}
                  </p>

                </div>

              ) : (

                <>

                  {error && (

                    <div className="
                      bg-red-50
                      border
                      border-red-200
                      text-red-600
                      rounded-xl
                      px-4
                      py-3
                      text-sm
                      mb-6
                    ">
                      {error}
                    </div>

                  )}


                  <label
                    htmlFor="new-email"
                    className="
                      block
                      text-sm
                      font-semibold
                      text-gray-700
                      mb-2
                    "
                  >
                    New email address
                  </label>


                  <div className="relative">

                    <FiMail className="
                      absolute
                      left-4
                      top-1/2
                      -translate-y-1/2
                      text-gray-400
                    " />

                    <input
                      id="new-email"
                      type="email"
                      value={email}
                      onChange={(event) =>
                        setEmail(
                          event.target.value
                        )
                      }
                      placeholder="you@example.com"
                      autoComplete="email"
                      className="
                        w-full
                        h-[52px]
                        pl-11
                        pr-4
                        border
                        border-gray-300
                        rounded-xl
                        outline-none
                        transition
                        focus:border-green-500
                        focus:ring-4
                        focus:ring-green-50
                      "
                    />

                  </div>


                  <div className="
                    flex
                    gap-3
                    items-start
                    bg-gray-50
                    rounded-xl
                    p-4
                    mt-5
                  ">

                    <FiShield className="
                      text-green-600
                      mt-0.5
                      shrink-0
                    " />

                    <p className="
                      text-xs
                      text-gray-500
                      leading-5
                    ">
                      We'll send a confirmation link to your new email address before making the change.
                    </p>

                  </div>


                  <button
                    type="submit"
                    disabled={loading}
                    className="
                      w-full
                      h-12
                      rounded-xl
                      bg-green-600
                      hover:bg-green-700
                      disabled:bg-green-400
                      text-white
                      font-bold
                      text-sm
                      transition
                      mt-7
                    "
                  >
                    {
                      loading
                        ? 'Sending confirmation...'
                        : 'Continue'
                    }
                  </button>

                </>

              )}

            </form>

          </div>

        </div>

      </main>

    </div>
  )
}